<template>
    <div>
        <template v-if="hasLinks">
            <h2 class="h5 p-2 font-weight-bold">{{ $lang('Pomocne linki') }} </h2>
            <ul v-for="useful_link in useful_links">
                <template v-for="linkCriterion in useful_link.criteria" >
                    <li v-if="linkCriterion.id===criterion_type" style="line-height: 0.8rem;">
                        <a :href="useful_link.url" target="_blank">{{useful_link.label}}</a>
                    </li>
                </template>
            </ul>
        </template>
    </div>
</template>

<script>

export default {
    name: "useful-links",
    props: {
        criterion_type: Number,
        useful_links: Array,
    },
    data() {
        return {
            hasLinks: false,
        }
    },
    created() {
        this.setHasLinks(this.criterion_type);
    },
    methods: {
        setHasLinks(criterion) {
            let criterionLinks = this.useful_links.filter(function (link){
                for (const linkCriterion of link.criteria) {
                    if (linkCriterion.id === criterion) return link;
                }
            });

            this.hasLinks = criterionLinks.length > 0;
        }
    },
    watch: {
        criterion_type: function () {
            this.setHasLinks(this.criterion_type);
        }
    }
}
</script>

<style scoped>

</style>
